import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { db } from '../../../firebase';
import { collection, getDocs, addDoc, doc, setDoc } from 'firebase/firestore';

const CreateRoleModal = ({ show, handleClose, handleSaveCreate, permissionsMap }) => {
    const [nom, setNom] = useState('');
    const [permissions, setPermissions] = useState([]);
    const [allPermissions, setAllPermissions] = useState([]);

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const permissionsCollection = collection(db, 'permissions');
                const permissionsSnapshot = await getDocs(permissionsCollection);
                const permissionsList = permissionsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setAllPermissions(permissionsList);
            } catch (error) {
                console.error("Error fetching permissions: ", error);
            }
        };

        fetchPermissions();
    }, []);

    const handleCheckboxChange = (permissionId) => {
        if (permissions.includes(permissionId)) {
            setPermissions(permissions.filter(id => id !== permissionId));
        } else {
            setPermissions([...permissions, permissionId]);
        }
    };

    const saveChanges = async () => {
        try {
            const newRoleRef = doc(collection(db, 'roles')); 
            const newRole = { id: newRoleRef.id, nom, permissions }; 
            await setDoc(newRoleRef, newRole); 
            handleSaveCreate(newRole);
            handleClose();
        } catch (error) {
            console.error("Error creating role: ", error);
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Créer un rôle</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formNom">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control
                            type="text"
                            value={nom}
                            onChange={(e) => setNom(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group controlId="formPermissions">
                        <Form.Label>Permissions</Form.Label>
                        {allPermissions
                            .filter(permission => permission.active) // Filtrer par active = true
                            .map(permission => (
                                <Form.Check
                                    key={permission.id}
                                    type="checkbox"
                                    label={permission.nom}
                                    checked={permissions.includes(permission.id)}
                                    onChange={() => handleCheckboxChange(permission.id)}
                                />
                            ))
                        }
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={saveChanges}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateRoleModal;
